module.exports = __webpack_public_path__ + "img/hr-branch-particle-14.b6faab3d.png";